import React from 'react';

export default function HealthCheck(req, res) {
  return <h1>success</h1>
  }